var React = require('react');

function SearchInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M16.6004 15.2001C17.4792 14.0302 18 12.5759 18 11C18 7.13401 14.866 4 11 4C7.13401 4 4 7.13401 4 11C4 14.866 7.13401 18 11 18C12.5759 18 14.0302 17.4792 15.2001 16.6004C15.2281 16.6376 15.259 16.6733 15.2929 16.7071L19.2929 20.7071C19.6834 21.0976 20.3166 21.0976 20.7071 20.7071C21.0976 20.3166 21.0976 19.6834 20.7071 19.2929L16.7071 15.2929C16.6733 15.259 16.6376 15.2281 16.6004 15.2001ZM11 16C8.23858 16 6 13.7614 6 11C6 8.23858 8.23858 6 11 6C13.7614 6 16 8.23858 16 11C16 13.7614 13.7614 16 11 16Z","fill":"#C7CBD5"}));
}

SearchInline.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = SearchInline;

SearchInline.default = SearchInline;
